import { render } from "./AppKontakti.vue?vue&type=template&id=084ff4c1"
import script from "./AppKontakti.vue?vue&type=script&lang=js"
export * from "./AppKontakti.vue?vue&type=script&lang=js"

import "./AppKontakti.vue?vue&type=style&index=0&id=084ff4c1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__